(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('RuoloFunzioneSearch', RuoloFunzioneSearch);

    RuoloFunzioneSearch.$inject = ['$resource'];

    function RuoloFunzioneSearch($resource) {
        var resourceUrl =  'api/_search/ruolo-funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
